import * as React from "react";

import DialogConfig from "./DialogConfig.interface";
import DialogContext from "./DialogContext";

const useDialog = (): ((config: DialogConfig) => void) => {
  const dialogContext = React.useContext(DialogContext);
  if (dialogContext == null) {
    throw new Error("useDialog must be used inside <DialogProvider>");
  }
  return dialogContext;
};

export default useDialog;
